import { Injectable } from "@angular/core";
import { SimuladorPrimaryInterface } from "../ports/primary/simulador.primary.interface";
import { Observable } from "rxjs";
import { CampusModel } from "../domain/campus.model";
import { InstitucionesModel } from "../domain/instituciones.model";
import { NivelAcademicosModel } from "../domain/nivelAcademico.model";
import { PeriodosModel } from "../domain/periodos.model";
import { ProgramasModel } from "../domain/programas.model";
import { SimuladorSecondaryInterface } from "../ports/secondary/simulador.secondaty.interface";
import { AreaModel } from "../domain/area.model";
import { CalcularRequestModel } from "../domain/params/requestCalcularRequest.model";
import { CalcularModel } from "../domain/calcular.model";
import { ApoyosModel } from "../domain/apoyos.model";
import { BecaModel } from "../domain/beca.model";
import { ParamApoyoModel } from "../domain/params/paramApoyo.model";
import { PrestamosModel } from "../domain/prestamos.model";
import { ParamCampusModel } from "../domain/params/paramCampus.model";
import { ParamPeriodoModel } from "../domain/params/paramPeriodo.model";
import { ParamAreaModel } from "../domain/params/paramArea.model";
import { ParamProgramasModel } from "../domain/params/paramProgramas.model";

@Injectable({
  providedIn: "root",
})
export class SimuladorUsecase extends SimuladorPrimaryInterface {
  constructor(private secondary: SimuladorSecondaryInterface) {
    super();
  }

  override getInstituciones(
    institucion: string
  ): Observable<InstitucionesModel> {
    return this.secondary.getInstituciones(institucion);
  }

  override getNivelAcademico(
    institucion: string
  ): Observable<NivelAcademicosModel> {
    return this.secondary.getNivelAcademico(institucion);
  }

  override getCampus(params: ParamCampusModel): Observable<CampusModel> {
    return this.secondary.getCampus(params);
  }

  override getAreas(params: ParamAreaModel): Observable<AreaModel> {
    return this.secondary.getAreas(params);
  }

  override getPeriodos(params: ParamPeriodoModel): Observable<PeriodosModel> {
    return this.secondary.getPeriodos(params);
  }

  override getProgramas(
    params: ParamProgramasModel
  ): Observable<ProgramasModel> {
    return this.secondary.getProgramas(params);
  }

  override calcular(request: CalcularRequestModel): Observable<CalcularModel> {
    return this.secondary.calcular(request);
  }

  override getBeca(institucion: string, nivelAcademico: string, periodo: string): Observable<BecaModel> {
    return this.secondary.getBeca(institucion, nivelAcademico, periodo);
  }

  override getApoyos(param: ParamApoyoModel): Observable<ApoyosModel> {
    return this.secondary.getApoyos(param);
  }

  override getPrestamos(institucion: string, nivelAcademico: string, periodo: string): Observable<PrestamosModel> {
    return this.secondary.getPrestamos(institucion, nivelAcademico, periodo);
  }
}
